import React, { useMemo } from 'react';
import { BarCustomLayerProps } from '@nivo/bar/dist/types/types';
import { BarDatum } from '@nivo/bar';
import { animated } from '@react-spring/web';

/**
 * Display placeholder for horizontal bars with 0 values. This component is
 * useful to alert the user a bar is not visible because of its value.
 */
export const BarChartBarPlaceholderLayer = (
  props: BarCustomLayerProps<BarDatum>,
) => {
  const totalWidth = props.bars.reduce((acc, bar) => acc + bar.width, 0);
  const totalHeight = props.bars.reduce((acc, bar) => acc + bar.height, 0);
  const shouldDisplayHorizontalBars = totalWidth > totalHeight;

  const zeroValueBars = useMemo(() => {
    return props.bars.filter(
      (bar) => bar.data.value === 0 && shouldDisplayHorizontalBars,
    );
  }, [props.bars, shouldDisplayHorizontalBars]);

  return (
    <g>
      {zeroValueBars.map((bar, barIndex) => {
        const rectWidth = bar.width;
        const rectHeight = bar.height;
        const rectX = shouldDisplayHorizontalBars ? bar.x + 9 : bar.x;
        const rectY = bar.y;

        return (
          <animated.g key={barIndex}>
            <text
              x={rectX + rectWidth / 2}
              y={rectY + rectHeight / 2 + 5}
              textAnchor="middle"
              style={{
                fill: '#696D70',
                fontSize: '12px',
                fontWeight: 'bold',
              }}
            >
              --
            </text>
          </animated.g>
        );
      })}
    </g>
  );
};
